import React, { useState } from 'react';
import {
  Redirect, Switch, useLocation,
} from 'react-router-dom';

import { Nav } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLink } from '@fortawesome/pro-solid-svg-icons';
import OrdersList from '../../../orders/OrdersList/OrdersList';
import QuotesList from '../../../quotes/QuotesList/QuotesList';
import RaaRoute from '../../../common/RaaRoute';

function OrdersPage() {
  const location = useLocation();
  const [isOrdersActiveTab, setIsOrdersActiveTab] = useState(true);

  React.useEffect(() => {
    if (location.pathname === '/s/orders/list') {
      setIsOrdersActiveTab(true);
    }
    if (location.pathname === '/s/orders/quotes/list') {
      setIsOrdersActiveTab(false);
    }
  }, [location]);
  /* istanbul ignore next */
  return (
    <>
      <div>
        <div className="row mb-4">
          <div className="col clearfix">
            <div className="float-left">
              {' '}
              <h2 className="mb-0">
                Orders and Quotes
              </h2>
            </div>
            <div className="float-right">
              {isOrdersActiveTab
                ? (
                  <a href="https://avtech.com/Products/Environment_Monitors/" target="_blank" rel="noopener noreferrer">
                    <button
                      type="button"
                      className="btn btn-primary"
                    >
                      <FontAwesomeIcon icon={faExternalLink} />
                      {' '}
                      Shop Now
                    </button>
                  </a>
                )
                : (
                  <a href="https://avtech.com/quote/" target="_blank" rel="noopener noreferrer">
                    <button
                      type="button"
                      className="btn btn-primary"
                    >
                      <FontAwesomeIcon icon={faExternalLink} />
                      {' '}
                      Request Quote
                    </button>
                  </a>
                )}
            </div>
          </div>
        </div>
        <Nav variant="tabs" className="mb-3">
          <Nav.Item>
            <LinkContainer to="/s/orders/list">
              <Nav.Link>Orders</Nav.Link>
            </LinkContainer>
          </Nav.Item>
          <Nav.Item>
            <LinkContainer to="/s/orders/quotes/list">
              <Nav.Link>Quotes</Nav.Link>
            </LinkContainer>
          </Nav.Item>
        </Nav>
      </div>

      <Switch>
        <RaaRoute path="/s/orders" exact minimumTierLevel={0}>
          <Redirect to="/s/orders/list" />
        </RaaRoute>
        <RaaRoute path="/s/orders/list" minimumTierLevel={0}>
          <OrdersList />
        </RaaRoute>
        <RaaRoute path="/s/orders/quotes/list" minimumTierLevel={0}>
          <QuotesList />
        </RaaRoute>
      </Switch>
    </>
  );
}
export default OrdersPage;
